/* eslint-disable react/require-default-props */
import React from 'react';
import { InputProps, Tooltip } from 'antd';
import { EyeInvisibleOutlined } from '@ant-design/icons';
import { withTheme, ThemeProps, DefaultTheme } from 'styled-components';
import { StyledInput, ActiveEyeTwoTone } from './styles';

interface IProps extends InputProps, ThemeProps<DefaultTheme> {
    error?: string;
}

const Input: React.FC<IProps> = ({ error, theme, name, ...rest }) => {
    return (
        <Tooltip placement="left" title={error ?? null}>
            <StyledInput
                name={name}
                id={name}
                iconRender={(visible) =>
                    visible ? (
                        <ActiveEyeTwoTone
                            twoToneColor={theme.colors.accentColor}
                        />
                    ) : (
                        <EyeInvisibleOutlined />
                    )
                }
                error={error}
                {...rest}
            />
        </Tooltip>
    );
};

export default withTheme(Input);
